import Vue from "vue";
import App from "./App.vue";

// apexchart
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts);

// Vuesax Component Framework
import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css"; //Material Icons
import "vuesax/dist/vuesax.css"; // Vuesax
Vue.use(Vuesax);

// Theme Configurations
import "../themeConfig.js";

// Globally Registered Components
import "./globalComponents.js";

// Styles: SCSS
import "./assets/scss/main.scss";

// Tailwind
import "@/assets/css/main.css";

// Vue Router
import router from "./router";

// Vuex Store
import store from "./store/store";

// Vuesax Admin Filters
import "./filters/filters";

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

// VeeValidate
// import VeeValidate from 'vee-validate';
// // Vue.use(VeeValidate);
// Vue.prototype.$validator = VeeValidate;

// PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

// Feather font icon
require("./assets/css/iconfont.css");

import { saveAs } from "file-saver";

import axios from "axios";

Vue.prototype.$http = axios;
//PRODUCTION-SERVER
Vue.prototype.$http.defaults.baseURL = "https://tvd-api-2025.goodang.com";

//DEVELOPMENT-SERVER
//Vue.prototype.$http.defaults.baseURL = "https://tvd-wms-api.inidev.xyz";


//server

//local
Vue.prototype.$http.defaults.onDownloadProgress = e => {
    // console.log(e);
};
// Vue.prototype.$http.defaults.baseURL = 'http://127.0.0.1:8000';

Vue.config.productionTip = false;

import _ from 'lodash'
Vue.prototype.$_ = _

Vue.prototype.$moment = require('moment')

import Cookies from 'js-cookie'
Vue.prototype.$Cookies = Cookies;

router.beforeEach((to, from, next) => {
    if (!store.state.user) {
        const token = Cookies.get('wms_session_token');

        if (token) {
            axios.get('session', {
                    headers: {
                        token: token
                    }
                })
                .then(res => {
                    store.dispatch('setUserState', res.data);
                    axios.defaults.headers.common[
                        "token"
                    ] = store.state.user.token;

                    if (to.path === '/auth') {
                        next({
                            path: "/dashboard"
                        });
                    } else {
                        next();
                    }
                })
                .catch(() => {
                    if (to.path === '/auth') {
                        next();
                    } else {
                        next({
                            path: "/auth"
                        });
                    }
                })
        } else {
            if (to.path === '/auth') {
                next();
            } else {
                next({
                    path: "/auth"
                });
            }
        }
    } else {
        next();
    }
});

router.afterEach((to, from) => {
    const menuName = to.meta.menuName;

    if (store.state.user) {
        let access = null;
        store.state.user.groupaccess.map(item => {
            if (menuName.toUpperCase() == item.menu.toUpperCase()) {
                access = item;
            }
        });

        store.commit("SET_ACCESS_STATE", access);
    }
});

Vue.mixin({
    methods: {
        handleError(error, blob = false) {
            if (blob) {
                var reader = new FileReader()
                const globalThis = this
                reader.onload = function() {
                    globalThis.isLoading = false
                    const object = JSON.parse(reader.result)
                    const message = object.message ? object.message : 'Server error.'

                    globalThis.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon: 'icon-x',
                        text: message
                    })
                }
                reader.readAsText(error.response.data)

                return false;
            }

            const message = error.response.data.message ?
                error.response.data.message :
                "Server error.";
            if (typeof message == "string") {
                this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: message
                });
            } else {
                message.map(msg => {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: msg
                    });
                });
            }
            this.isLoading = false;
        },
        isNumber(e) {
            e = e ? e : window.event;
            let charCode = e.which ? e.which : e.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46
            ) {
                e.preventDefault();
            } else {
                return true;
            }
        },
        exportExcel(params) {
            const { endpoint, filter, name } = params;
            this.isLoading = true;
            this.$http
                .post(endpoint, filter, { responseType: "blob" })
                .then(response => {
                    var blob = new Blob([response.data], {
                        type: "application/pdf"
                    });
                    this.isLoading = false;
                    saveAs(blob, `${name}_list_export_${Date.now()}.xlsx`);
                })
                .catch(error => this.handleError(error))
        },
        getTemplate(params) {
            const { endpoint, name } = params;
            this.isLoading = true;
            this.$http
                .get(endpoint + "/report/get_template", {
                    responseType: "blob"
                })
                .then(response => {
                    var blob = new Blob([response.data]);
                    this.isLoading = false;
                    saveAs(blob, `${name}_template_${Date.now()}.xlsx`);
                });
        },
        searchDropdown(event, parent) {
            parent.loading = true;
            const query = {
                [parent.objectKey]: event.target.value
            };

            this.$http.post(parent.endpoint, query).then(res => {
                parent.loading = false;
                res.data.data.map(d => {
                    if (parent.data.findIndex(p => p.id === d.id) === -1) {
                        parent.data.push(d);
                    }
                });
            });
        },
        pushClientWarehouse(client, warehouse) {
            const clientDefault = store.state.user.userconfig.clients;
            const warehouseDefault = store.state.user.userconfig.warehouses;

            if (clientDefault) {
                if (client.findIndex(c => c.id === clientDefault.id) === -1) {
                    client.push(clientDefault);
                }
            }

            if (warehouseDefault) {
                if (
                    warehouse.findIndex(w => w.id === warehouseDefault.id) ===
                    -1
                ) {
                    warehouse.push(warehouseDefault);
                }
            }
        },
        async confirmAll(params) {
            return axios.post('inventories/movementorder/confirmall', params)
        },
        confirmMo(params) {
            /** params - Object
             * transaction_source - Int
             * transaction_types - Array
             */

            const { transaction_source, transaction_types } = params;
            const moData = [];

            this.$vs.dialog({
                type: "confirm",
                color: "success",
                title: "Confirmation",
                text: "Confirm movement orders?",
                accept: () => {
                    this.$vs.loading();
                    const data = {
                        transaction_source: transaction_source,
                        transaction_types: transaction_types
                    };
                    this.$http
                        .post("inventories/movementorder/getoutstanding", data)
                        .then(res => {
                            res.data.movement_order_id.map(item => {
                                moData.push({
                                    id: item
                                });
                            });
                            return acceptMo(moData);
                        })
                        .catch(error => {
                            this.handleError(error);
                            this.$vs.loading.close();
                        });
                },
                acceptText: "Yes",
                cancelText: "No"
            });

            const acceptMo = data => {
                this.$http
                    .post("putaway/confirmputaway", {
                        list_putaway: JSON.stringify(data)
                    })
                    .then(() => {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            iconPack: "feather",
                            icon: "icon-check",
                            text: "Success confirm"
                        });

                        this.$vs.loading.close();
                    })
                    .catch(error => this.handleError(error));
            };
        },
        focusInput(refName, hasLabel = false, delay = 0) {
            let index = hasLabel ? 1 : 0;

            setTimeout(() => {
                this.$refs[refName].$el.children[index].children[0].focus();
            }, delay)
        },
        hasAccess(name) {
            if (this.$store.state.access[name]) {
                return true;
            }

            return false;
        },
        getUserDefault(key) {
            const data = store.state.user.userconfig[key];

            if (!data) {
                return null;
            }

            return data;
        },
        getFilter() {
            const routeName = this.$route.name;
            const filter = store.state.filter[routeName];

            if (filter) {
                return _.cloneDeep(filter);
            }

            return false;
        },
        setFilter(filter) {
            const routeName = this.$route.name;
            filter.key = routeName;

            store.dispatch('setFilterState', filter);
        }
    }
});

let vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");

global.vm = vm;

let timeout = 180000;
let timeoutId;

function startTimer() {
    timeoutId = window.setTimeout(doInactive, timeout);
}

function doInactive() {
    if (store.state.user) {
        // location.reload();
    }
}

function resetTimer() {
    window.clearTimeout(timeoutId);
    startTimer();
}

function setupTimers() {
    document.addEventListener("mousemove", resetTimer, false);
    document.addEventListener("mousedown", resetTimer, false);
    document.addEventListener("keypress", resetTimer, false);
    document.addEventListener("touchmove", resetTimer, false);

    startTimer();
}

setupTimers();
setInterval(function() {
    if (store.state.user) {
        Vue.prototype.$http.post("/update_session");
    }
}, 60000);
